import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import {
  getCurrencySymbol,
  getSelectedCountry,
} from "../../functions/CountryFunctions";
import "./orderSummary.css";

const OrderSummary = ({ totalPrice }) => {
  const order = useSelector((state) => state.basket.basket || []);
  const currencySymbol = getCurrencySymbol(getSelectedCountry());

  const groupedOrder = useMemo(() => {
    const grouped = new Map();

    order.forEach((item) => {
      const key = `${item.id}__${item.variantId || ""}__${item.colour || ""}__${item.size || ""}`;

      if (!grouped.has(key)) {
        grouped.set(key, {
          key,
          title: item.title,
          size: item.size,
          colour: item.colour,
          images: item.images || [],
          quantity: 1,
        });
      } else {
        const existing = grouped.get(key);
        existing.quantity += 1;
      }
    });

    return Array.from(grouped.values());
  }, [order]);

  if (!order || order.length === 0) {
    return (
      <div className="order-summary">
        <h2>Order Summary</h2>
        <p className="order-summary-empty">No items found.</p>
      </div>
    );
  }

  return (
    <div className="order-summary">
      <h2>Order Summary</h2>

      <div className="order-summary-items">
        {groupedOrder.map((item) => (
          <div key={item.key} className="order-summary-item">
            <div className="order-summary-thumb">
              {item.images && item.images[0] ? (
                <img src={item.images[0]} alt={item.title} />
              ) : (
                <div className="order-summary-no-image">No image</div>
              )}
            </div>

            <div className="order-summary-meta">
              <div className="order-summary-topline">
                <p className="order-summary-title">{item.title}</p>
                <span className="order-summary-qty">x{item.quantity}</span>
              </div>

              {item.size && (
                <p className="order-summary-size">Size: {item.size}</p>
              )}

              {item.colour && (
                <p className="order-summary-colour">Colour: {item.colour}</p>
              )}
            </div>
          </div>
        ))}
      </div>

      <div className="order-summary-lines">
        <div className="order-summary-line">
          <span>Subtotal</span>
          <span>
            {currencySymbol}
            {totalPrice.toFixed(2)}
          </span>
        </div>

        <div className="order-summary-line">
          <span>Delivery</span>
          <span>Free</span>
        </div>
      </div>

      <div className="order-summary-total">
        <span>Total</span>
        <span>
          {currencySymbol}
          {totalPrice.toFixed(2)}
        </span>
      </div>
    </div>
  );
};

export default OrderSummary;
